var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _ellipse12, _ellipse13, _ellipse14, _ellipse15, _ellipse16, _ellipse17, _ellipse18, _ellipse19, _ellipse20, _ellipse21, _ellipse22, _ellipse23, _ellipse24, _ellipse25, _ellipse26, _ellipse27, _ellipse28, _ellipse29, _ellipse30, _ellipse31, _ellipse32, _ellipse33, _ellipse34, _ellipse35, _ellipse36, _ellipse37, _ellipse38, _ellipse39, _ellipse40, _ellipse41, _ellipse42, _ellipse43, _ellipse44, _ellipse45, _ellipse46, _ellipse47, _ellipse48, _ellipse49, _ellipse50, _ellipse51, _ellipse52, _ellipse53, _ellipse54, _ellipse55, _ellipse56, _ellipse57, _ellipse58, _ellipse59, _ellipse60, _ellipse61, _ellipse62, _ellipse63, _ellipse64, _ellipse65, _ellipse66, _ellipse67, _ellipse68, _ellipse69, _ellipse70;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServices1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 625,
    height: 462,
    viewBox: "0 0 625 462",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M493.527 209.685C451.694 81.2098 226.907 75.6243 209.643 219.771C209.643 219.771 196.316 222.407 184.562 220.609C120.466 210.812 8.31084 333.44 94.3877 427.147H575.074C627.083 337.656 589.725 246.091 493.527 209.685Z",
    fill: "#DFF3FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M378.018 290.132L377.19 289.326C430.843 234.218 432.977 204.076 436.205 158.455C437.348 142.299 438.64 124.022 442.357 101.964C416.946 113.764 396.35 130.105 381.123 150.551C368.783 167.122 359.917 186.413 354.776 207.89C346.015 244.489 351.19 275.154 351.243 275.46L350.104 275.659C350.049 275.351 344.834 244.489 353.641 207.665C358.815 186.026 367.744 166.587 380.179 149.883C395.722 129.004 416.815 112.375 442.869 100.454L443.866 100L443.68 101.079C439.832 123.567 438.518 142.146 437.357 158.538C434.114 204.414 431.969 234.721 378.018 290.132Z",
    fill: "#DADADA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M367.906 278.295L366.784 278.007C366.998 277.181 388.365 194.779 415.245 149.038L416.244 149.623C389.445 195.227 368.12 277.469 367.906 278.295Z",
    fill: "#DADADA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M397.537 187.763L396.38 187.721C396.387 187.555 396.87 171.015 388.22 155.097L389.237 154.547C398.042 170.753 397.543 187.595 397.537 187.763Z",
    fill: "#DADADA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M385.203 221.267L384.39 220.448C396.684 208.25 412.748 204.482 412.908 204.445L413.164 205.572C413.008 205.607 397.257 209.309 385.203 221.267Z",
    fill: "#DADADA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M418.833 325.445L418.719 324.294C439.639 322.223 456.611 308.217 470.6 281.476C482.993 257.784 491.507 227.51 499.741 198.235C505.078 179.254 510.129 161.303 516.021 145.759C455.813 160.792 430.859 208.473 430.611 208.956L429.582 208.432C429.833 207.94 455.303 159.234 516.819 144.374L517.889 144.116L517.495 145.143C511.452 160.873 506.305 179.174 500.856 198.549C492.607 227.881 484.075 258.212 471.625 282.011C457.439 309.126 440.171 323.333 418.833 325.445Z",
    fill: "#DADADA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M413.708 297.059L412.652 296.592C413.004 295.799 448.171 217.116 477.715 194.239L478.423 195.152C466.312 204.53 451.289 225.114 434.971 254.677C422.622 277.048 413.795 296.862 413.708 297.059Z",
    fill: "#DADADA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M452.57 224.891L451.433 224.679C451.451 224.591 453.082 215.681 454.534 194.154L455.688 194.232C454.23 215.843 452.588 224.803 452.57 224.891Z",
    fill: "#DADADA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M432.853 258.404L432.197 257.452C432.356 257.343 448.423 246.397 469.513 241.591L469.769 242.718C448.893 247.476 433.01 258.297 432.853 258.404Z",
    fill: "#DADADA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M152.725 400.969C100.768 347.604 98.7014 318.414 95.5769 274.23C94.4597 258.446 93.1937 240.553 89.4898 218.899L89.3062 217.82L90.301 218.277C147.14 244.278 168.406 288.778 176.238 321.531C184.719 356.997 179.697 386.723 179.644 387.017L178.505 386.819C178.556 386.524 183.538 356.999 175.103 321.756C167.372 289.462 146.463 245.645 90.8126 219.784C94.3875 241.008 95.6316 258.597 96.7314 274.145C99.8384 318.076 101.891 347.095 153.555 400.159L152.725 400.969Z",
    fill: "#DADADA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M162.459 389.562C162.255 388.767 141.718 309.569 115.911 265.658L116.908 265.073C142.798 309.126 163.375 388.478 163.578 389.273L162.459 389.562Z",
    fill: "#DADADA"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M133.923 302.374C133.916 302.212 133.435 285.986 141.917 270.375L142.933 270.925C134.607 286.251 135.073 302.173 135.077 302.332L133.923 302.374Z",
    fill: "#DADADA"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M145.807 334.652C134.205 323.143 119.042 319.58 118.891 319.543L119.149 318.418C119.304 318.453 134.778 322.081 146.622 333.833L145.807 334.652Z",
    fill: "#DADADA"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M117.013 421.24C72.3744 417.092 54.5044 367.655 38.7377 324.034C33.4093 309.292 28.3739 295.366 22.536 283.38L22.02 282.323L23.1745 282.561C53.328 288.831 74.1148 301.974 86.2409 311.896C99.3969 322.658 105.506 332.084 105.565 332.178L104.59 332.8C104.354 332.431 80.4861 296.083 24.0884 283.938C29.7361 295.733 34.6425 309.303 39.8244 323.643C55.473 366.938 73.2118 416.011 117.118 420.091L117.013 421.24Z",
    fill: "#DADADA"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M121.458 399.761C121.122 399.158 87.4041 339.336 59.7212 321.791L60.34 320.814C88.2677 338.517 122.127 398.592 122.466 399.195L121.458 399.761Z",
    fill: "#DADADA"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2164 344.557C84.2011 344.489 82.5525 337.665 80.9258 321.256L82.0759 321.142C83.6917 337.451 85.3228 344.216 85.3381 344.281L84.2164 344.557Z",
    fill: "#DADADA"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M103.114 370.274C102.965 370.189 87.9619 361.794 68.3755 357.938L68.5985 356.805C88.3773 360.697 103.534 369.182 103.685 369.267L103.114 370.274Z",
    fill: "#DADADA"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M532.029 426.36L531.755 425.237C580.905 413.247 590.171 360.501 599.134 309.495C602.28 291.591 605.531 273.09 610.501 257.076C561.577 266.44 533.863 300.189 519.203 326.946C503.191 356.169 498.858 383.596 498.816 383.869L497.673 383.694C497.714 383.419 502.072 355.819 518.173 326.422C533.048 299.261 561.266 264.955 611.238 255.761L612.185 255.586L611.894 256.503C606.782 272.653 603.474 291.484 600.275 309.694C591.245 361.068 581.913 414.191 532.029 426.36Z",
    fill: "#DADADA"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M527.822 397.447L526.707 397.139C526.886 396.49 545.008 332.125 574.479 306.705L575.236 307.581C546.029 332.769 528.001 396.803 527.822 397.447Z",
    fill: "#DADADA"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M548.653 343.478L547.52 343.244C547.546 343.113 550.194 329.998 549.265 310.742L550.421 310.686C551.355 330.098 548.679 343.345 548.653 343.478Z",
    fill: "#DADADA"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M533.067 371.492L532.356 370.579C532.516 370.455 548.689 357.977 571.035 350.05L571.422 351.138C549.251 359.006 533.227 371.368 533.067 371.492Z",
    fill: "#DADADA"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M418.63 190.039C416.557 190.039 414.871 188.355 414.871 186.282C414.871 184.209 416.557 182.524 418.63 182.524C420.702 182.524 422.388 184.209 422.388 186.282C422.388 188.355 420.702 190.039 418.63 190.039ZM418.63 183.682C417.195 183.682 416.028 184.849 416.028 186.282C416.028 187.715 417.195 188.881 418.63 188.881C420.064 188.881 421.232 187.715 421.232 186.282C421.232 184.849 420.064 183.682 418.63 183.682Z",
    fill: "#DADADA"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M106.899 248.111C104.826 248.111 103.138 246.427 103.138 244.354C103.138 242.281 104.824 240.597 106.899 240.597C108.974 240.597 110.657 242.281 110.657 244.354C110.657 246.427 108.972 248.111 106.899 248.111ZM106.899 241.755C105.465 241.755 104.297 242.921 104.297 244.354C104.297 245.787 105.465 246.954 106.899 246.954C108.333 246.954 109.501 245.787 109.501 244.354C109.501 242.924 108.333 241.755 106.899 241.755Z",
    fill: "#DADADA"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M455.645 331.802C453.572 331.802 451.886 330.118 451.886 328.047C451.886 325.976 453.572 324.292 455.645 324.292C457.718 324.292 459.403 325.976 459.403 328.047C459.403 330.118 457.718 331.802 455.645 331.802ZM455.645 325.448C454.21 325.448 453.043 326.614 453.043 328.047C453.043 329.48 454.21 330.646 455.645 330.646C457.079 330.646 458.247 329.48 458.247 328.047C458.249 326.614 457.079 325.448 455.645 325.448Z",
    fill: "#DADADA"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M583.557 291.738C581.485 291.738 579.799 290.054 579.799 287.983C579.799 285.912 581.485 284.226 583.557 284.226C585.63 284.226 587.316 285.91 587.316 287.983C587.316 290.054 585.63 291.738 583.557 291.738ZM583.557 285.381C582.123 285.381 580.955 286.548 580.955 287.983C580.955 289.416 582.123 290.582 583.557 290.582C584.992 290.582 586.159 289.416 586.159 287.983C586.159 286.55 584.992 285.381 583.557 285.381Z",
    fill: "#DADADA"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M443.21 281.048C444.647 281.048 445.812 279.884 445.812 278.448C445.812 277.012 444.647 275.849 443.21 275.849C441.773 275.849 440.608 277.012 440.608 278.448C440.608 279.884 441.773 281.048 443.21 281.048Z",
    fill: "#DADADA"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M563.026 376.779C564.463 376.779 565.628 375.615 565.628 374.18C565.628 372.744 564.463 371.58 563.026 371.58C561.589 371.58 560.424 372.744 560.424 374.18C560.424 375.615 561.589 376.779 563.026 376.779Z",
    fill: "#DADADA"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M374.097 204.199C374.099 202.764 372.936 201.598 371.499 201.596C370.062 201.594 368.895 202.756 368.893 204.192C368.891 205.628 370.055 206.793 371.492 206.795C372.929 206.797 374.095 205.635 374.097 204.199Z",
    fill: "#DADADA"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M84.1507 385.255C85.5877 385.255 86.7526 384.091 86.7526 382.655C86.7526 381.219 85.5877 380.056 84.1507 380.056C82.7137 380.056 81.5488 381.219 81.5488 382.655C81.5488 384.091 82.7137 385.255 84.1507 385.255Z",
    fill: "#DADADA"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M158.265 205.723C157.933 205.723 157.596 205.675 157.261 205.575L150.066 203.427C149.167 203.159 148.428 202.558 147.984 201.734C147.54 200.913 147.446 199.967 147.715 199.076L150.166 190.944C147.123 189.329 144.333 187.304 141.858 184.912L134.844 189.644C133.241 190.723 131.059 190.303 129.974 188.709L125.768 182.516C125.243 181.743 125.05 180.814 125.227 179.897C125.405 178.98 125.929 178.184 126.705 177.662L133.639 172.988C132.169 169.532 131.249 165.873 130.901 162.096L122.676 161.155C121.744 161.048 120.909 160.585 120.328 159.853C119.746 159.123 119.486 158.21 119.593 157.284L120.452 149.853C120.673 147.937 122.416 146.559 124.338 146.779L132.456 147.71C133.545 144.304 135.126 141.089 137.159 138.14L131.553 132.33C130.904 131.657 130.556 130.772 130.573 129.839C130.593 128.904 130.973 128.035 131.651 127.386L137.067 122.2C138.462 120.864 140.686 120.907 142.024 122.297L147.58 128.052C150.733 126.034 154.159 124.52 157.773 123.548L157.257 115.614C157.132 113.692 158.599 112.023 160.528 111.899L168.023 111.412C169.976 111.283 171.624 112.749 171.751 114.671L172.269 122.607C175.98 123.103 179.57 124.16 182.957 125.752L187.719 119.324C188.867 117.773 191.066 117.443 192.621 118.585L198.664 123.026C199.419 123.581 199.911 124.394 200.051 125.318C200.19 126.242 199.961 127.163 199.403 127.915L194.6 134.4C196.998 137.063 198.981 140.047 200.503 143.282L208.431 141.307C210.309 140.844 212.216 141.982 212.684 143.852L214.501 151.111C214.726 152.015 214.588 152.955 214.107 153.754C213.624 154.556 212.857 155.122 211.947 155.349L203.914 157.347C204.061 161.137 203.623 164.884 202.613 168.501L210.093 172.239C210.93 172.658 211.556 173.377 211.851 174.263C212.146 175.15 212.076 176.096 211.656 176.931L208.289 183.617C207.421 185.338 205.311 186.037 203.582 185.175L196.01 181.393C193.869 184.085 191.364 186.455 188.554 188.449L192.042 196.197C192.424 197.049 192.453 197.997 192.12 198.869C191.788 199.742 191.132 200.435 190.275 200.817L183.422 203.877C181.658 204.664 179.581 203.877 178.789 202.119L175.284 194.332C173.457 194.736 171.585 195.002 169.715 195.122C167.846 195.245 165.955 195.223 164.088 195.059L161.626 203.233C161.171 204.745 159.774 205.723 158.265 205.723ZM141.995 183.425L142.332 183.759C144.921 186.326 147.877 188.471 151.122 190.137L151.55 190.358L148.822 199.41C148.642 200.009 148.706 200.64 149.001 201.188C149.298 201.739 149.795 202.143 150.396 202.322L157.592 204.469C158.836 204.838 160.148 204.135 160.517 202.899L163.254 193.816L163.729 193.864C165.686 194.061 167.676 194.096 169.639 193.969C171.605 193.84 173.57 193.547 175.483 193.1L175.947 192.99L179.841 201.643C180.37 202.82 181.763 203.347 182.946 202.82L189.798 199.76C190.373 199.504 190.811 199.041 191.034 198.453C191.257 197.87 191.237 197.237 190.981 196.667L187.1 188.045L187.496 187.772C190.5 185.697 193.154 183.187 195.385 180.308L195.675 179.932L204.096 184.137C205.257 184.718 206.671 184.248 207.251 183.093L210.618 176.406C210.898 175.849 210.946 175.216 210.749 174.624C210.552 174.03 210.135 173.549 209.573 173.267L201.229 169.1L201.365 168.636C202.478 164.851 202.939 160.91 202.733 156.928L202.709 156.452L211.665 154.224C212.275 154.073 212.789 153.693 213.112 153.156C213.434 152.62 213.528 151.993 213.377 151.388L211.56 144.13C211.247 142.878 209.971 142.113 208.711 142.428L199.849 144.634L199.65 144.195C198.089 140.761 195.997 137.609 193.426 134.828L193.1 134.477L198.472 127.227C198.844 126.724 198.999 126.106 198.905 125.49C198.811 124.872 198.483 124.328 197.978 123.957L191.934 119.516C190.891 118.749 189.416 118.972 188.648 120.009L183.315 127.207L182.882 126.997C179.34 125.276 175.562 124.164 171.651 123.692L171.174 123.636L170.594 114.745C170.509 113.458 169.388 112.482 168.098 112.563L160.602 113.05C159.31 113.135 158.326 114.249 158.409 115.538L158.989 124.426L158.523 124.544C154.705 125.516 151.102 127.109 147.811 129.276L147.409 129.54L141.186 123.094C140.288 122.163 138.797 122.135 137.863 123.031L132.447 128.216C131.995 128.649 131.739 129.232 131.726 129.857C131.713 130.482 131.946 131.073 132.379 131.523L138.648 138.018L138.37 138.409C136.182 141.495 134.513 144.892 133.411 148.501L133.271 148.962L124.198 147.924C122.908 147.764 121.74 148.699 121.594 149.982L120.734 157.413C120.662 158.033 120.837 158.643 121.226 159.13C121.618 159.621 122.175 159.932 122.8 160.001L131.968 161.05L132.005 161.524C132.323 165.5 133.291 169.346 134.883 172.959L135.077 173.401L127.346 178.613C126.826 178.964 126.474 179.495 126.356 180.109C126.238 180.721 126.364 181.343 126.716 181.861L130.923 188.054C131.651 189.122 133.114 189.404 134.188 188.678L141.995 183.425ZM167.341 179.982C156.361 179.982 147.09 171.459 146.368 160.388C145.616 148.857 154.423 138.861 166.001 138.109C171.609 137.745 177.02 139.577 181.245 143.267C185.469 146.958 187.994 152.07 188.359 157.655C188.725 163.243 186.881 168.636 183.173 172.846C179.465 177.053 174.335 179.572 168.727 179.936C168.261 179.967 167.8 179.982 167.341 179.982ZM167.4 139.219C166.961 139.219 166.519 139.234 166.075 139.263C155.134 139.975 146.812 149.418 147.521 160.314C148.231 171.212 157.718 179.495 168.649 178.785C173.948 178.44 178.796 176.061 182.301 172.086C185.806 168.11 187.546 163.014 187.201 157.734C186.857 152.457 184.47 147.627 180.479 144.138C176.826 140.94 172.223 139.219 167.4 139.219Z",
    fill: "#DADADA"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M344.246 426.57H172.18C166.226 426.57 161.398 421.747 161.398 415.799V164.536C161.398 158.588 166.226 153.765 172.18 153.765H344.246C350.2 153.765 355.028 158.588 355.028 164.536V415.799C355.028 421.749 350.2 426.57 344.246 426.57Z",
    fill: "#86A7FF"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M292.337 165.768H224.091V177.214H292.337V165.768Z",
    fill: "#D3DFFF"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M335.713 194.661H180.714V229.004H335.713V194.661Z",
    fill: "#DADADA"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M328.93 199.357H187.496V224.305H328.93V199.357Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M295.287 258.802H284.757C281.595 258.802 279.033 256.241 279.033 253.083V250.649C279.033 247.491 281.595 244.931 284.757 244.931H295.287C298.449 244.931 301.011 247.491 301.011 250.649V253.083C301.011 256.241 298.449 258.802 295.287 258.802Z",
    fill: "#1F3C88"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M329.989 258.802H319.459C316.297 258.802 313.734 256.241 313.734 253.083V250.649C313.734 247.491 316.297 244.931 319.459 244.931H329.989C333.15 244.931 335.713 247.491 335.713 250.649V253.083C335.713 256.241 333.15 258.802 329.989 258.802Z",
    fill: "#1F3C88"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M332.982 293.664H311.83C310.326 293.664 309.104 292.445 309.104 290.94V278.28C309.104 276.777 310.324 275.556 311.83 275.556H332.982C334.486 275.556 335.708 276.775 335.708 278.28V290.94C335.708 292.445 334.488 293.664 332.982 293.664Z",
    fill: "#1F3C88"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M290.54 293.664H269.388C267.884 293.664 266.662 292.445 266.662 290.94V278.28C266.662 276.777 267.882 275.556 269.388 275.556H290.54C292.044 275.556 293.267 276.775 293.267 278.28V290.94C293.264 292.445 292.044 293.664 290.54 293.664Z",
    fill: "#1F3C88"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M248.097 293.664H226.945C225.441 293.664 224.218 292.445 224.218 290.94V278.28C224.218 276.777 225.438 275.556 226.945 275.556H248.097C249.601 275.556 250.823 276.775 250.823 278.28V290.94C250.821 292.445 249.601 293.664 248.097 293.664Z",
    fill: "#1F3C88"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M205.653 293.664H184.501C182.997 293.664 181.774 292.445 181.774 290.94V278.28C181.774 276.777 182.994 275.556 184.501 275.556H205.653C207.157 275.556 208.379 276.775 208.379 278.28V290.94C208.379 292.445 207.159 293.664 205.653 293.664Z",
    fill: "#1F3C88"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M332.982 326.411H311.83C310.326 326.411 309.104 325.192 309.104 323.687V311.026C309.104 309.523 310.324 308.302 311.83 308.302H332.982C334.486 308.302 335.708 309.521 335.708 311.026V323.687C335.708 325.192 334.488 326.411 332.982 326.411Z",
    fill: "#1F3C88"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M290.54 326.411H269.388C267.884 326.411 266.662 325.192 266.662 323.687V311.026C266.662 309.523 267.882 308.302 269.388 308.302H290.54C292.044 308.302 293.267 309.521 293.267 311.026V323.687C293.264 325.192 292.044 326.411 290.54 326.411Z",
    fill: "#D3DFFF"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M248.097 326.411H226.945C225.441 326.411 224.218 325.192 224.218 323.687V311.026C224.218 309.523 225.438 308.302 226.945 308.302H248.097C249.601 308.302 250.823 309.521 250.823 311.026V323.687C250.821 325.192 249.601 326.411 248.097 326.411Z",
    fill: "#D3DFFF"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M205.653 326.411H184.501C182.997 326.411 181.774 325.192 181.774 323.687V311.026C181.774 309.523 182.994 308.302 184.501 308.302H205.653C207.157 308.302 208.379 309.521 208.379 311.026V323.687C208.379 325.192 207.159 326.411 205.653 326.411Z",
    fill: "#D3DFFF"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M332.982 359.155H311.83C310.326 359.155 309.104 357.936 309.104 356.431V343.77C309.104 342.267 310.324 341.046 311.83 341.046H332.982C334.486 341.046 335.708 342.265 335.708 343.77V356.431C335.708 357.936 334.488 359.155 332.982 359.155Z",
    fill: "#1F3C88"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M290.54 359.155H269.388C267.884 359.155 266.662 357.936 266.662 356.431V343.77C266.662 342.267 267.882 341.046 269.388 341.046H290.54C292.044 341.046 293.267 342.265 293.267 343.77V356.431C293.264 357.936 292.044 359.155 290.54 359.155Z",
    fill: "#D3DFFF"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M248.097 359.155H226.945C225.441 359.155 224.218 357.936 224.218 356.431V343.77C224.218 342.267 225.438 341.046 226.945 341.046H248.097C249.601 341.046 250.823 342.265 250.823 343.77V356.431C250.821 357.936 249.601 359.155 248.097 359.155Z",
    fill: "#D3DFFF"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M205.653 359.155H184.501C182.997 359.155 181.774 357.936 181.774 356.431V343.77C181.774 342.267 182.994 341.046 184.501 341.046H205.653C207.157 341.046 208.379 342.265 208.379 343.77V356.431C208.379 357.936 207.159 359.155 205.653 359.155Z",
    fill: "#D3DFFF"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M332.982 393.054H311.83C310.326 393.054 309.104 391.836 309.104 390.331V377.67C309.104 376.167 310.324 374.946 311.83 374.946H332.982C334.486 374.946 335.708 376.165 335.708 377.67V390.331C335.708 391.836 334.488 393.054 332.982 393.054Z",
    fill: "#FBC343"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M290.54 393.054H269.388C267.884 393.054 266.662 391.836 266.662 390.331V377.67C266.662 376.167 267.882 374.946 269.388 374.946H290.54C292.044 374.946 293.267 376.165 293.267 377.67V390.331C293.264 391.836 292.044 393.054 290.54 393.054Z",
    fill: "#D3DFFF"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M248.097 393.054H226.945C225.441 393.054 224.218 391.836 224.218 390.331V377.67C224.218 376.167 225.438 374.946 226.945 374.946H248.097C249.601 374.946 250.823 376.165 250.823 377.67V390.331C250.821 391.836 249.601 393.054 248.097 393.054Z",
    fill: "#D3DFFF"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M205.653 393.054H184.501C182.997 393.054 181.774 391.836 181.774 390.331V377.67C181.774 376.167 182.994 374.946 184.501 374.946H205.653C207.157 374.946 208.379 376.165 208.379 377.67V390.331C208.379 391.836 207.159 393.054 205.653 393.054Z",
    fill: "#D3DFFF"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M298.134 217.487C298.543 217.531 299.017 217.487 299.66 217.422C300.755 217.273 301.79 216.821 302.583 216.07C303.508 215.231 304.175 214.008 304.433 212.354H304.37C303.593 213.298 302.476 213.857 301.081 213.857C298.565 213.857 296.953 211.967 296.953 209.582C296.953 206.939 298.866 204.619 301.726 204.619C304.586 204.619 306.348 206.939 306.348 210.504C306.348 213.575 305.316 215.725 303.941 217.057C302.865 218.11 301.381 218.754 299.879 218.927C299.19 219.034 298.589 219.056 298.136 219.034V217.487H298.134ZM298.823 209.455C298.823 211.194 299.876 212.42 301.51 212.42C302.78 212.42 303.768 211.797 304.262 210.958C304.372 210.788 304.433 210.572 304.433 210.27C304.433 207.887 303.552 206.061 301.573 206.061C299.962 206.061 298.823 207.479 298.823 209.455Z",
    fill: "#3A6BEA"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M309.171 217.487C309.58 217.531 310.055 217.487 310.698 217.422C311.793 217.273 312.827 216.821 313.621 216.07C314.546 215.231 315.213 214.008 315.471 212.354H315.407C314.631 213.298 313.514 213.857 312.119 213.857C309.602 213.857 307.991 211.967 307.991 209.582C307.991 206.939 309.904 204.619 312.764 204.619C315.624 204.619 317.386 206.939 317.386 210.504C317.386 213.575 316.354 215.725 314.979 217.057C313.903 218.11 312.418 218.754 310.916 218.927C310.227 219.034 309.626 219.056 309.174 219.034V217.487H309.171ZM309.858 209.455C309.858 211.194 310.912 212.42 312.545 212.42C313.813 212.42 314.804 211.797 315.298 210.958C315.407 210.788 315.468 210.572 315.468 210.27C315.468 207.887 314.587 206.061 312.609 206.061C310.997 206.061 309.858 207.479 309.858 209.455Z",
    fill: "#3A6BEA"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M511.548 349.727H405.907V427.147H511.548V349.727Z",
    fill: "#FBC343"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M511.55 367.254H483.404V368.41H511.55V367.254Z",
    fill: "#E49B31"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M511.55 409.63H462.584V410.785H511.55V409.63Z",
    fill: "#E49B31"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M458.57 377.782C458.57 386.692 457.227 395.648 454.499 404.35C450.347 417.573 438.096 426.564 424.24 426.564H405.907V349.734H454.026C457.033 358.771 458.57 368.247 458.57 377.782Z",
    fill: "#E49B31"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M361.95 413.649V421.902C361.95 424.803 359.602 427.149 356.698 427.149H269.609C266.705 427.149 264.357 424.803 264.357 421.902V413.649C264.357 410.748 266.705 408.402 269.609 408.402H356.698C359.602 408.402 361.95 410.748 361.95 413.649Z",
    fill: "#FBC343"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M351.16 394.892V403.156C351.16 406.056 348.801 408.402 345.908 408.402H258.819C255.915 408.402 253.567 406.056 253.567 403.156V394.892C253.567 392.002 255.915 389.645 258.819 389.645H345.908C348.798 389.645 351.16 392.004 351.16 394.892Z",
    fill: "#FBC343"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M361.95 413.649V421.902C361.95 424.803 359.602 427.149 356.698 427.149H294.248C289.934 421.832 287.297 414.979 285.712 408.404C283.884 400.868 283.41 393.717 283.307 389.647H345.908C348.801 389.647 351.16 392.004 351.16 394.894V403.157C351.16 406.058 348.801 408.404 345.908 408.404H356.7C359.602 408.402 361.95 410.748 361.95 413.649Z",
    fill: "#E49B31"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M407.721 259.92L400.688 281.497L400.167 283.092L396.905 293.112L396.881 293.182L386.366 292.95L346.019 292.037L343.07 283.601L342.573 282.192L334.766 259.922C358.989 268.297 378.954 249.981 407.721 259.92Z",
    fill: "#FBC343"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M400.169 283.09L396.907 293.109L386.371 292.948L346.024 292.035L343.074 283.599C356.943 283.356 380.806 283.033 400.169 283.09Z",
    fill: "#E49B31"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M445.246 404.936C443.175 411.546 439.069 417.094 433.76 421C428.438 424.905 421.916 427.149 414.987 427.149H323.608C310.4 427.149 298.809 418.33 295.291 405.595C293.266 398.234 292.18 390.768 292.007 383.336C291.996 382.62 291.983 381.903 291.983 381.187C291.983 380.339 291.994 379.494 292.018 378.649C292.763 351.715 305.937 326.631 327.078 309.905L348.938 292.614L398.965 293.769L426.464 320.059C430.332 323.757 433.777 327.89 436.543 332.47C439.858 337.96 442.541 343.753 444.574 349.738C450.578 367.375 450.97 386.698 445.246 404.936Z",
    fill: "#FBC343"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M363.876 403.007V393.347C357.052 393.041 350.438 391.211 346.566 388.974L349.625 377.071C353.904 379.406 359.906 381.545 366.528 381.545C372.331 381.545 376.302 379.308 376.302 375.241C376.302 371.372 373.044 368.928 365.507 366.385C354.614 362.724 347.176 357.639 347.176 347.772C347.176 338.818 353.493 331.802 364.388 329.665V320H374.36V328.953C381.184 329.259 385.767 330.686 389.126 332.309L386.174 343.805C383.528 342.687 378.845 340.343 371.507 340.343C364.891 340.343 362.752 343.191 362.752 346.042C362.752 349.397 366.316 351.534 374.973 354.788C387.086 359.063 391.977 364.653 391.977 373.814C391.977 382.869 385.559 390.597 373.853 392.635V403.007H363.876Z",
    fill: "white"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M407.242 301.943H336.475C333.547 301.943 331.153 299.551 331.153 296.626V294.363C331.153 291.438 333.547 289.046 336.475 289.046H407.242C410.17 289.046 412.564 291.438 412.564 294.363V296.626C412.566 299.551 410.17 301.943 407.242 301.943Z",
    fill: "#ED7545"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M445.245 404.936C443.175 411.546 439.069 417.094 433.76 421C428.438 424.905 421.916 427.149 414.987 427.149H323.608C310.399 427.149 298.809 418.33 295.291 405.595C293.266 398.234 292.18 390.768 292.007 383.336C307.124 397.736 324.937 416.563 366.578 417.14C418.288 417.856 440.573 393.644 444.574 349.74C450.578 367.375 450.97 386.698 445.245 404.936Z",
    fill: "#E49B31"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3186 411.161L81.0655 407.695L59.5703 426.57H85.0077L90.3186 411.161Z",
    fill: "#102048"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3187 411.161H110.753L108.44 425.799L85.0078 426.57L90.3187 411.161Z",
    fill: "#F9B384"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M172.344 329.102L171.592 334.222L171.142 337.309L167.903 359.487L166.666 367.958L165.566 375.516L162.686 395.209L160.686 408.87C159.182 419.143 150.368 426.76 139.969 426.76H94.7529L94.8098 426.181L96.2791 411.157L96.4868 409.042L128.007 402.974L132.24 372.255C130.158 363.321 130.668 354.723 131.569 348.69C132.332 343.547 133.397 340.275 133.397 340.275L147.462 336.243L172.344 329.102Z",
    fill: "#1F3C88"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M162.686 395.208L160.686 408.87C159.182 419.143 150.368 426.76 139.969 426.76H137.656C158.37 423.055 154.323 396.617 162.686 395.208Z",
    fill: "#102048"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6623 419.139L74.228 426.265L75.2103 426.875L79.6446 419.749L78.6623 419.139Z",
    fill: "white"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M167.903 359.487L165.566 375.516C159.055 373.655 150.466 364.356 150.466 364.356L167.903 359.487Z",
    fill: "#102048"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M215.811 400.374C215.811 400.374 204.822 406.008 185.159 402.397L201.498 391.562L215.811 400.374Z",
    fill: "#102048"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M209.763 408.14L192.192 408.533L192.09 404.743L191.812 394.354L207.428 395.51L208.167 399.518L209.763 408.14Z",
    fill: "#F9B384"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M208.167 399.518L192.09 404.743L191.812 394.354L207.428 395.51L208.167 399.518Z",
    fill: "#E28B6D"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M229.693 426.714L210.316 411.113L209.767 408.145L192.19 408.533L192.678 426.714H229.693Z",
    fill: "#102048"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M216.488 415.482L209.546 419.813L210.159 420.793L217.1 416.462L216.488 415.482Z",
    fill: "white"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M133.396 340.277L196.268 330.301C199.209 329.833 202.222 330.229 204.942 331.437C210.349 333.837 213.902 339.121 214.084 345.03L215.809 400.372C215.809 400.372 197.88 396.617 185.157 402.395L184 364.546C176.312 368.043 162.997 368.783 149.502 367.436L133.396 340.277Z",
    fill: "#1F3C88"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M206.954 398.64H205.797C205.797 389.063 206.029 381.114 206.232 374.1C206.728 357.02 207.002 347.614 202.648 343.632C199.124 340.41 192.081 340.511 181.864 341.719C170.914 342.994 166.548 331.347 166.504 331.229L167.591 330.836C167.752 331.284 171.688 341.78 181.726 340.572C192.54 339.296 199.561 339.246 203.427 342.782C208.174 347.121 207.909 356.149 207.386 374.137C207.183 381.14 206.954 389.081 206.954 398.64Z",
    fill: "#3A6BEA"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M185.181 395.424L184.77 394.343C184.916 394.289 199.583 388.834 215.767 392.877L215.487 393.998C199.668 390.046 185.325 395.37 185.181 395.424Z",
    fill: "#3A6BEA"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M101.174 426.926C99.3727 423.326 102.16 408.413 102.281 407.779L103.418 407.996C102.624 412.201 100.857 423.708 102.211 426.41L101.174 426.926Z",
    fill: "#3A6BEA"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M166.086 335.655C166.086 335.655 161.646 345.096 151.627 351.453C148.227 353.602 144.884 354.585 141.889 354.596C137.367 354.607 133.606 352.412 131.571 348.69C132.334 343.547 133.399 340.275 133.399 340.275L147.464 336.243L161.657 335.793L166.086 335.655Z",
    fill: "#102048"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M154.795 278.75V292.125H167.905V280.556L154.795 278.75Z",
    fill: "#ED7545"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M167.905 272.286H154.795V278.749L167.905 280.556V272.286Z",
    fill: "#F9B384"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M158.661 274.114C158.949 274.114 161.822 278.616 167.905 280.556L167.818 273.537L158.661 274.114Z",
    fill: "#102048"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M169.447 256.298C169.447 256.298 176.675 275.752 167.326 277.004C157.976 278.255 156.529 274.018 156.529 274.018L153.636 263.712L160.095 255.044L169.447 256.298Z",
    fill: "#F9B384"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M173.876 265.68C173.896 264.564 173.007 263.641 171.889 263.621C170.771 263.6 169.848 264.489 169.827 265.606C169.806 266.722 170.696 267.645 171.814 267.665C172.932 267.686 173.855 266.797 173.876 265.68Z",
    fill: "#F9B384"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M159.614 265.542C159.614 265.542 160.095 255.14 169.447 256.296C169.447 256.296 163.154 248.222 154.863 251.353C150.652 252.943 147.836 256.96 147.423 261.438C146.889 267.227 150.274 273.823 154.996 274.979C154.996 274.979 156.538 271.416 159.131 266.89L159.614 265.542Z",
    fill: "#102048"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M160.695 269.263C162.117 268.596 162.636 266.708 161.854 265.047C161.073 263.387 159.287 262.582 157.865 263.25C156.444 263.917 155.924 265.805 156.706 267.465C157.487 269.126 159.273 269.931 160.695 269.263Z",
    fill: "#F9B384"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M168.929 266.837C168.95 265.375 167.781 264.173 166.317 264.152C164.854 264.131 163.651 265.299 163.63 266.761C163.609 268.223 164.778 269.425 166.242 269.446C167.705 269.467 168.908 268.299 168.929 266.837Z",
    fill: "#EB5D60"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M159.866 267.373C159.706 267.373 159.577 267.244 159.577 267.085C159.577 267.017 159.544 265.405 157.754 265.156C157.596 265.134 157.485 264.988 157.507 264.828C157.529 264.671 157.675 264.568 157.832 264.581C160.126 264.902 160.154 267.06 160.154 267.082C160.154 267.244 160.025 267.373 159.866 267.373Z",
    fill: "#102048"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M203.665 259.669C203.665 259.669 213.777 260.44 219.281 266.893L206.759 269.975L203.665 259.669Z",
    fill: "#BA5C36"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M221.585 254.133C221.631 255.057 219.086 259.669 217.212 262.939C216.112 264.822 215.257 266.255 215.257 266.255L208.514 268.218L203.702 260.973L203.47 260.614C203.47 260.614 203.54 260.302 203.667 259.747V259.736C203.678 259.725 203.678 259.701 203.691 259.666C204.5 256.235 207.369 244.537 209.024 244.146C210.482 243.812 209.625 250.215 209.625 250.215C209.625 250.215 213.222 239.802 215.351 240.23C217.053 240.564 213.72 250.551 213.72 250.551C213.72 250.551 214.912 249.304 216.115 249.695C217.398 250.123 217.56 251.324 217.56 251.324C217.56 251.324 218.415 250.724 219.272 251.232C220.127 251.752 220.046 253.371 220.046 253.371C220.046 253.371 221.493 252.687 221.585 254.133Z",
    fill: "#F9B384"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M151.732 287.428L147.151 305.318L140.05 333.055C135.226 335.194 130.136 335.98 126.1 335.31C121.414 334.537 118.141 331.808 118.362 326.989C118.939 313.986 151.732 287.428 151.732 287.428Z",
    fill: "#ED7545"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M150.853 292.509L147.151 305.318L140.05 333.056C135.226 335.194 130.136 335.981 126.1 335.31C136.394 305.801 150.853 292.509 150.853 292.509Z",
    fill: "#BA5C36"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M179.481 332.986C169.939 333.632 139.864 358.48 132.633 342.451C132.633 342.451 133.639 282.655 164.536 283.765C170.007 283.961 174.808 287.603 176.461 292.815C177.202 295.172 177.941 298.247 178.521 302.199C179.111 306.209 179.551 311.133 179.701 317.131C179.828 321.754 179.769 327.012 179.481 332.986Z",
    fill: "#ED7545"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M179.701 317.129C174.924 314.043 169.938 304.739 169.938 304.739L178.52 302.197C179.111 306.21 179.55 311.131 179.701 317.129Z",
    fill: "#BA5C36"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M217.212 262.939C216.112 264.822 215.257 266.255 215.257 266.255L208.514 268.218L203.702 260.973L203.667 259.747V259.667H203.691L217.212 262.939Z",
    fill: "#E28B6D"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M164.538 283.765C164.538 283.765 179.375 284.805 188.34 286.539L203.667 259.669C208.348 263.411 213.552 265.825 219.283 266.893L205.869 298.468C202.911 304.464 196.891 308.35 190.203 308.58L167.23 309.364L164.538 283.765Z",
    fill: "#ED7545"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M188.34 286.971C188.313 286.971 188.287 286.969 188.261 286.965C187.979 286.912 159.964 281.779 155.188 285.997C155.009 286.154 154.736 286.139 154.576 285.958C154.419 285.779 154.434 285.506 154.613 285.346C159.701 280.853 187.249 285.894 188.418 286.113C188.655 286.157 188.81 286.384 188.766 286.617C188.727 286.827 188.545 286.971 188.34 286.971Z",
    fill: "#BA5C36"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M495.357 401.915L497.286 426.571H465.188L481.381 415.399L481.093 399.991L495.357 401.915Z",
    fill: "#102048"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M542.685 391.419L551.361 412.509L529.385 431L532.564 410.198L528.229 396.329L542.685 391.419Z",
    fill: "#102048"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M503.843 272.474C503.554 273.282 503.288 274.324 503.034 275.548C502.605 277.686 502.236 280.412 501.923 283.625C500.904 294.119 500.478 309.709 500.362 326.272C500.119 363.566 501.53 405.773 501.53 405.773L495.655 405.681L481.196 405.46L476.084 405.38C468.335 346.3 470.543 296.409 471.711 279.038C471.746 278.438 471.792 277.883 471.816 277.363C472.058 274.174 472.22 272.474 472.22 272.474H503.843Z",
    fill: "#1F3C88"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M548.18 396.908L545.242 397.636L529.834 401.485L520.419 403.842C520.419 403.842 509.268 362.502 500.362 326.271C496.083 308.798 492.312 292.514 490.576 282.632C489.974 279.141 489.616 276.447 489.57 274.785L503.034 275.548L520.038 276.517C520.038 276.517 520.454 278.955 521.265 283.337C524.503 300.801 533.999 349.155 548.18 396.908Z",
    fill: "#1F3C88"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M521.265 283.337C514.417 283.903 507.892 283.927 501.925 283.625C497.865 283.418 494.061 283.06 490.578 282.632C481.972 281.557 475.331 279.997 471.713 279.038C469.734 278.507 468.658 278.16 468.658 278.16L471.816 277.363L491.295 272.474H503.845C503.556 273.282 503.29 274.324 503.036 275.548L520.04 276.517C520.038 276.52 520.453 278.957 521.265 283.337Z",
    fill: "#102048"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M500.963 330.782C500.028 326.863 495.609 308.307 495.034 305.164L486.093 301.815L486.5 300.731L496.129 304.338V304.738C496.195 305.594 499.73 320.623 502.089 330.511L500.963 330.782Z",
    fill: "#3A6BEA"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M478.266 347.696C474.059 347.696 471.387 346.654 471.238 346.593L471.667 345.52C471.713 345.54 476.431 347.366 483.102 346.068L483.323 347.202C481.471 347.562 479.77 347.696 478.266 347.696Z",
    fill: "#3A6BEA"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M511.753 346.886C509.06 346.886 506.801 346.466 506.624 346.433L506.84 345.297C506.919 345.313 514.742 346.759 518.354 344.236L519.017 345.182C517.091 346.527 514.237 346.886 511.753 346.886Z",
    fill: "#3A6BEA"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M481.747 414.961L481.043 415.878L485.573 419.346L486.277 418.429L481.747 414.961Z",
    fill: "white"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M532.787 409.665L532.352 410.735L538.521 413.238L538.956 412.168L532.787 409.665Z",
    fill: "white"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M486.876 209.301C486.876 209.301 467.019 211.804 462.007 234.148L467.983 260.73L465.285 278.45C465.285 278.45 492.275 281.146 520.036 276.524L511.603 231.354L486.876 209.301Z",
    fill: "#ED7545"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M499.214 265.929C499.214 265.929 493.239 261.547 501.047 242.333L506.253 261.256L499.214 265.929Z",
    fill: "#6E3620"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M475.926 241.778L474.483 239.054L496.7 227.302C497.321 226.975 498.091 227.211 498.419 227.831L498.672 228.309C499 228.93 498.764 229.699 498.143 230.026L475.926 241.778Z",
    fill: "#102048"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M504.226 259.669L503.635 259.346L495.967 255.209L483.115 248.262C482.884 246.713 483.059 245.396 483.983 244.494L483.347 244.241C482.306 243.802 481.543 242.864 481.336 241.744L481.312 241.606C480.977 240.486 481.139 239.446 481.242 238.867L481.543 238.474C482.295 237.491 482.63 236.995 483.603 236.22L481.961 236.311C481.961 236.311 477.912 237.421 479.799 234.822C481.095 233.019 483.997 231.492 485.652 230.73C486.345 230.407 487.191 230.544 487.722 231.099C493.287 236.866 503.071 243.778 503.071 243.778L503.176 245.186L504.125 258.164L504.226 259.669Z",
    fill: "#F9B384"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M489.06 237.585L485.56 235.876C485.195 235.697 484.788 235.641 484.388 235.71L480.66 236.359L480.562 235.789L484.289 235.14C484.812 235.049 485.339 235.125 485.816 235.357L489.316 237.065L489.06 237.585Z",
    fill: "#E28B6D"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M488.411 240.87L484.213 239.262C484.027 239.19 483.83 239.155 483.629 239.155H481.239V238.579H483.629C483.9 238.579 484.167 238.627 484.421 238.725L488.619 240.333L488.411 240.87Z",
    fill: "#E28B6D"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M487.831 244.144L484.018 242.705C483.721 242.591 483.393 242.55 483.072 242.587L481.51 242.764L481.445 242.189L483.008 242.012C483.417 241.966 483.839 242.019 484.226 242.165L488.039 243.605L487.831 244.144Z",
    fill: "#E28B6D"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M504.121 258.166L503.636 259.345L495.968 255.208L501.045 242.333L503.174 245.188L504.121 258.166Z",
    fill: "#E28B6D"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M499.214 265.929C499.214 265.929 510.687 276.812 520.036 276.523L517.336 263.714L499.214 265.929Z",
    fill: "#BA5C36"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M486.876 209.301C486.876 209.301 488.289 209.154 490.644 209.235C513.798 210.026 531.535 229.932 530.405 253.052C529.937 262.609 527.453 272.098 519.457 272.288L499.215 265.931C501.123 258.777 502.549 251.359 501.047 242.335L510.444 246.814L486.876 209.301Z",
    fill: "#ED7545"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M493.479 265.043L465.187 265.737L464.413 263.343L461.566 254.608L453.332 229.332L481.624 228.64L493.479 265.043Z",
    fill: "#D3DFFF"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M467.57 251.58C467.57 251.58 467.524 259.392 464.412 263.345L461.568 254.608L467.57 251.58Z",
    fill: "#1F3C88"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M453.847 250.968C454.74 248.094 456.362 245.44 458.148 243.045C458.717 242.283 459.952 240.411 461.139 240.695C463.549 241.274 461.139 245.509 461.139 245.509C461.139 245.509 463.453 242.043 464.321 243.775C465.189 245.509 463.936 247.434 463.936 247.434C463.936 247.434 467.598 245.027 466.249 249.841C466.249 249.841 469.238 249.457 467.406 252.731C466.098 255.068 465.252 257.672 463.614 259.822C461.966 261.984 458.865 263.199 456.29 261.965C453.261 260.514 452.874 256.646 453.248 253.701C453.366 252.77 453.572 251.86 453.847 250.968Z",
    fill: "#F9B384"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M459.042 250.206C459.003 250.206 458.964 250.197 458.924 250.182C458.778 250.116 458.712 249.946 458.778 249.8L461.524 243.587C461.588 243.441 461.76 243.375 461.905 243.441C462.051 243.506 462.117 243.677 462.051 243.823L459.305 250.036C459.259 250.143 459.154 250.206 459.042 250.206Z",
    fill: "#E28B6D"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M461.861 252.519C461.819 252.519 461.778 252.511 461.738 252.491C461.594 252.423 461.531 252.251 461.598 252.106L464.2 246.545C464.27 246.401 464.443 246.34 464.585 246.405C464.729 246.473 464.793 246.645 464.725 246.79L462.123 252.351C462.075 252.456 461.97 252.519 461.861 252.519Z",
    fill: "#E28B6D"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M464.03 254.396C463.984 254.396 463.938 254.385 463.894 254.363C463.754 254.289 463.697 254.114 463.774 253.972L466.015 249.71C466.092 249.571 466.264 249.516 466.406 249.59C466.546 249.665 466.603 249.839 466.527 249.981L464.286 254.243C464.235 254.339 464.135 254.396 464.03 254.396Z",
    fill: "#E28B6D"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M473.381 231.162H463.26L461.524 227.696H471.645L473.381 231.162Z",
    fill: "#102048"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M486.601 220.588C483.599 220.588 481.626 219.104 481.598 219.082C481.408 218.936 481.375 218.665 481.519 218.475C481.666 218.287 481.937 218.25 482.127 218.397C482.293 218.521 486.218 221.439 491.472 218.272C491.675 218.148 491.944 218.215 492.067 218.418C492.189 218.624 492.124 218.89 491.918 219.013C489.959 220.197 488.144 220.588 486.601 220.588Z",
    fill: "#BA5C36"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M499.215 266.362C499.175 266.362 499.134 266.355 499.092 266.344C498.863 266.276 498.731 266.034 498.799 265.805C502.958 251.735 500.651 242.534 500.627 242.442L500.459 241.796L518.372 244.795C518.608 244.834 518.768 245.057 518.729 245.293C518.689 245.531 518.453 245.691 518.23 245.649L501.604 242.864C502.048 245.217 503.233 253.869 499.634 266.049C499.575 266.239 499.403 266.362 499.215 266.362Z",
    fill: "#BA5C36"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M512.322 244.5C512.314 244.5 512.305 244.5 512.296 244.5C512.058 244.485 511.874 244.28 511.889 244.041C511.894 243.948 512.375 234.627 505.89 225.048C505.756 224.849 505.809 224.581 506.006 224.447C506.205 224.314 506.474 224.364 506.609 224.563C513.265 234.395 512.762 243.998 512.755 244.094C512.742 244.323 512.55 244.5 512.322 244.5Z",
    fill: "#BA5C36"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M494.828 198.663V209.816C494.828 213.414 492.021 216.33 488.555 216.33C485.09 216.33 482.282 213.414 482.282 209.816V198.663H494.828Z",
    fill: "#F9B384"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M488.898 200.15C488.898 200.15 488.247 207.042 482.282 209.034V199.244L488.898 200.15Z",
    fill: "#102048"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M477.548 185.95C477.548 185.95 475.602 201.594 481.707 203.449C487.812 205.306 493.385 199.914 493.385 199.914L492.235 187.011L483.211 181.708L477.548 185.95Z",
    fill: "#F9B384"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M512.276 216.355L500.235 217.152C498.711 215.476 497.85 213.12 497.286 210.461C496.779 213.198 497.179 215.472 498.523 217.268L495.261 217.488C492.369 213.165 489.939 203.598 492.808 195.415L493.143 193.484C493.143 193.484 491.083 187.254 488.098 186.99C488.098 186.99 477.861 193.89 473.305 186.192C469.905 180.461 472.773 172.924 480.951 178.484C480.951 178.484 500.603 169.272 500.557 188.156C500.546 191.542 501.818 194.871 504.328 197.136C504.536 197.344 504.768 197.54 505.011 197.726C509.419 201.215 514.174 208.172 512.276 216.355Z",
    fill: "#102048"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M496.197 194.482C496.778 192.68 495.998 190.816 494.455 190.319C492.911 189.822 491.188 190.881 490.607 192.684C490.026 194.486 490.806 196.35 492.35 196.847C493.893 197.344 495.616 196.285 496.197 194.482Z",
    fill: "#F9B384"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M493.044 194.661C492.884 194.661 492.755 194.532 492.755 194.373C492.755 193.126 493.741 192.025 494.909 191.966C494.913 191.966 494.92 191.966 494.924 191.966C495.077 191.966 495.204 192.086 495.213 192.241C495.222 192.401 495.097 192.536 494.937 192.545C494.163 192.584 493.333 193.329 493.333 194.375C493.333 194.532 493.204 194.661 493.044 194.661Z",
    fill: "#102048"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M479.694 191.915C479.694 192.315 479.37 192.638 478.97 192.638C478.57 192.638 478.246 192.315 478.246 191.915C478.246 191.516 478.57 191.192 478.97 191.192C479.37 191.195 479.694 191.518 479.694 191.915Z",
    fill: "#102048"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M484.055 191.555C484.055 191.955 483.732 192.278 483.332 192.278C482.932 192.278 482.608 191.955 482.608 191.555C482.608 191.155 482.932 190.832 483.332 190.832C483.732 190.832 484.055 191.158 484.055 191.555Z",
    fill: "#102048"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M480.73 196.756C480.658 196.756 480.583 196.73 480.529 196.673C479.94 196.099 479.7 195.555 479.814 195.052C479.929 194.543 480.38 194.249 480.649 194.113L480.585 192.687C480.579 192.527 480.703 192.392 480.861 192.385C481.018 192.385 481.156 192.503 481.163 192.66L481.243 194.502L481.04 194.572C480.881 194.626 480.45 194.845 480.375 195.181C480.295 195.544 480.631 195.968 480.931 196.258C481.045 196.37 481.047 196.553 480.935 196.667C480.881 196.728 480.806 196.756 480.73 196.756Z",
    fill: "#102048"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M481.314 198.838C481.073 198.838 480.92 198.816 480.9 198.811C480.743 198.787 480.636 198.639 480.662 198.482C480.686 198.324 480.848 198.219 480.992 198.241C481.008 198.244 482.473 198.453 483.758 197.335C483.876 197.23 484.06 197.241 484.165 197.363C484.27 197.483 484.259 197.667 484.136 197.772C483.072 198.698 481.915 198.838 481.314 198.838Z",
    fill: "#102048"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M486.929 196.756C487.977 196.756 488.826 195.907 488.826 194.86C488.826 193.813 487.977 192.964 486.929 192.964C485.88 192.964 485.031 193.813 485.031 194.86C485.031 195.907 485.88 196.756 486.929 196.756Z",
    fill: "#EB5D60"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M624.608 425.993H7.33789V427.149H624.608V425.993Z",
    fill: "#102048"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 521.646,
    cy: 3.59435,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 521.646,
    cy: 26.5983,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 521.646,
    cy: 49.6022,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 521.646,
    cy: 72.6061,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 521.646,
    cy: 95.61,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 521.646,
    cy: 118.613,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 521.646,
    cy: 141.617,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 546.11,
    cy: 3.59435,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 546.11,
    cy: 26.5983,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 546.11,
    cy: 49.6022,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 546.11,
    cy: 72.6061,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 546.11,
    cy: 95.61,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 546.11,
    cy: 118.613,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 546.11,
    cy: 141.617,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 570.573,
    cy: 3.59435,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 570.573,
    cy: 26.5983,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 570.573,
    cy: 49.6022,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 570.573,
    cy: 72.6061,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  })), _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 570.573,
    cy: 95.61,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  })), _ellipse20 || (_ellipse20 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 570.573,
    cy: 118.613,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  })), _ellipse21 || (_ellipse21 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 570.573,
    cy: 141.617,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  })), _ellipse22 || (_ellipse22 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 595.036,
    cy: 3.59435,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  })), _ellipse23 || (_ellipse23 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 595.036,
    cy: 26.5983,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  })), _ellipse24 || (_ellipse24 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 595.036,
    cy: 49.6022,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  })), _ellipse25 || (_ellipse25 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 595.036,
    cy: 72.6061,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  })), _ellipse26 || (_ellipse26 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 595.036,
    cy: 95.61,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  })), _ellipse27 || (_ellipse27 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 595.036,
    cy: 118.613,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  })), _ellipse28 || (_ellipse28 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 595.036,
    cy: 141.617,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  })), _ellipse29 || (_ellipse29 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 619.5,
    cy: 3.59435,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  })), _ellipse30 || (_ellipse30 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 619.5,
    cy: 26.5983,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  })), _ellipse31 || (_ellipse31 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 619.5,
    cy: 49.6022,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  })), _ellipse32 || (_ellipse32 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 619.5,
    cy: 72.6061,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  })), _ellipse33 || (_ellipse33 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 619.5,
    cy: 95.61,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  })), _ellipse34 || (_ellipse34 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 619.5,
    cy: 118.613,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  })), _ellipse35 || (_ellipse35 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 619.5,
    cy: 141.617,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  })), _ellipse36 || (_ellipse36 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.59756,
    cy: 319.897,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  })), _ellipse37 || (_ellipse37 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.59756,
    cy: 342.901,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  })), _ellipse38 || (_ellipse38 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.59756,
    cy: 365.905,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  })), _ellipse39 || (_ellipse39 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.59756,
    cy: 388.909,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  })), _ellipse40 || (_ellipse40 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.59756,
    cy: 411.913,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  })), _ellipse41 || (_ellipse41 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.59756,
    cy: 434.916,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  })), _ellipse42 || (_ellipse42 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.59756,
    cy: 457.92,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  })), _ellipse43 || (_ellipse43 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.0609,
    cy: 319.897,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  })), _ellipse44 || (_ellipse44 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.0609,
    cy: 342.901,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  })), _ellipse45 || (_ellipse45 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.0609,
    cy: 365.905,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  })), _ellipse46 || (_ellipse46 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.0609,
    cy: 388.909,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  })), _ellipse47 || (_ellipse47 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.0609,
    cy: 411.913,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  })), _ellipse48 || (_ellipse48 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.0609,
    cy: 434.916,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  })), _ellipse49 || (_ellipse49 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.0609,
    cy: 457.92,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  })), _ellipse50 || (_ellipse50 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 52.5243,
    cy: 319.897,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  })), _ellipse51 || (_ellipse51 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 52.5243,
    cy: 342.901,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  })), _ellipse52 || (_ellipse52 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 52.5243,
    cy: 365.905,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  })), _ellipse53 || (_ellipse53 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 52.5243,
    cy: 388.909,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  })), _ellipse54 || (_ellipse54 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 52.5243,
    cy: 411.913,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  })), _ellipse55 || (_ellipse55 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 52.5243,
    cy: 434.916,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  })), _ellipse56 || (_ellipse56 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 52.5243,
    cy: 457.92,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  })), _ellipse57 || (_ellipse57 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 76.9877,
    cy: 319.897,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  })), _ellipse58 || (_ellipse58 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 76.9877,
    cy: 342.901,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  })), _ellipse59 || (_ellipse59 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 76.9877,
    cy: 365.905,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  })), _ellipse60 || (_ellipse60 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 76.9877,
    cy: 388.909,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  })), _ellipse61 || (_ellipse61 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 76.9877,
    cy: 411.913,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  })), _ellipse62 || (_ellipse62 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 76.9877,
    cy: 434.916,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  })), _ellipse63 || (_ellipse63 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 76.9877,
    cy: 457.92,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  })), _ellipse64 || (_ellipse64 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 101.451,
    cy: 319.897,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  })), _ellipse65 || (_ellipse65 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 101.451,
    cy: 342.901,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  })), _ellipse66 || (_ellipse66 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 101.451,
    cy: 365.905,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  })), _ellipse67 || (_ellipse67 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 101.451,
    cy: 388.909,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  })), _ellipse68 || (_ellipse68 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 101.451,
    cy: 411.913,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  })), _ellipse69 || (_ellipse69 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 101.451,
    cy: 434.916,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  })), _ellipse70 || (_ellipse70 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 101.451,
    cy: 457.92,
    rx: 3.59756,
    ry: 3.59435,
    fill: "#D9D9D9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServices1);
export default __webpack_public_path__ + "static/media/services1.e73fd0e82e5d94300482feb34b92aed0.svg";
export { ForwardRef as ReactComponent };